'use client';

import { useFeatureGate } from '@statsig/react-bindings';
import { PropsWithChildren, ReactNode } from 'react';

import {
  findUniversalCobrandedPartner,
  matchCobrandedPartner,
} from '@/app/configs/cobrandedPartners';
import { CobrandedProvider } from '@/app/contexts/CobrandedProvider';
import SessionProvider from '@/app/contexts/SessionProvider';
import { useAccountData, useEligibilityData, useOrderData } from '@/app/hooks';
import { Partner } from '@/configs/partner';

import MaintenancePage from './maintenance/page';

export default function Layout({ children }: PropsWithChildren): ReactNode {
  const { value: isPartnerGateEnabled } = useFeatureGate('business');
  const { orders } = useAccountData();
  const order = useOrderData();
  const eligibility = useEligibilityData();

  // Not enough to do a truthy check due to redux store default value initialization.
  const selectedOrderOrEligibility = order.salesOrderId
    ? order
    : eligibility.id
      ? eligibility
      : undefined;

  // If we have a specific order or eligibility in the redux store, we are on a page that is specific to that order or eligibility.
  // That means we could safely supply the provider with that cobrand if it exists.
  const cobrandedConfig = selectedOrderOrEligibility
    ? matchCobrandedPartner(selectedOrderOrEligibility)
    : findUniversalCobrandedPartner(orders);

  if (isPartnerGateEnabled) {
    return (
      <SessionProvider partner={Partner.business}>
        <CobrandedProvider config={cobrandedConfig}>
          {children}
        </CobrandedProvider>
      </SessionProvider>
    );
  }

  return <MaintenancePage />;
}
